import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=64185b43&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=64185b43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64185b43",
  null
  
)

export default component.exports